import React from 'react';
import { Global } from '@emotion/react';
import { MediaQueryProvider } from 'react-media-query-hoc';
import * as styles from './landing-page.style';

interface LandingPage2026Props {
  skipLinkContentId: string;
}

const LandingPage2026 = ({
  skipLinkContentId,
}: LandingPage2026Props): JSX.Element => (
  <MediaQueryProvider values={{ width: 300, type: 'screen' }}>
    <div css={styles.container}>
      <Global styles={styles.globalStyle} />
    </div>
    <div id={skipLinkContentId}>Landing Page 2026</div>
  </MediaQueryProvider>
);

export default LandingPage2026;
